import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchArticleCategories(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('customer/article-categories', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteArticleCategory(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`customer/article-categories/${id}/delete`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
